import {
  Button,
  Card,
  CircularProgress,
  Grid,
  IconButton,
  InputLabel,
  Tooltip,
} from "@material-ui/core";
import { AddRounded, DeleteRounded, InfoOutlined } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import Swal from "sweetalert2";

import { UploadImage } from "../../../../components";
import {
  getValuesData,
  updValuesData,
} from "../../../../redux/actions/ValuesActions";

const Values = () => {
  const [submit, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({
    img: "",
    img_ori: "",
    img_preview: "",
    title: "",
    title_id: "",
    title_en: "",
    values: [],
  });
  const handleChange = ({ target: { value, name } }) => {
    setParams((pref) => ({
      ...pref,
      [name]: value,
    }));
  };
  const handleChangeValues = ({ target: { value, name } }, index) => {
    let data = params;
    data.values[index][name] = value;

    setParams((pref) => ({
      ...pref,
      ...data,
    }));
  };
  const handleFormSubmit = () => {
    setSubmit(true);
    updValuesData(params)
      .then(() => {
        showAlert("Data berhasil disimpan", true);
        setSubmit(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal menyimpan data, coba beberapa saat lagi",
          false
        );
        setSubmit(false);
      });
  };
  const showAlert = (text, success) => {
    Swal.fire({
      title: success ? "Berhasil" : "Oopss!",
      text: text,
      imageUrl: `/assets/images/icons/${
        success ? "ic_success" : "ic_error"
      }.svg`,
      imageWidth: 92,
      imageHeight: 92,
      confirmButtonText: "Ok",
      confirmButtonColor: "#0083E2",
    });
  };
  const getData = () => {
    setLoading(true);
    getValuesData()
      .then((res) => {
        let data = res.data?.data;
        if (Object.keys(data).length > 0) {
          setParams((pref) => ({
            ...pref,
            ...data,
            img: "",
          }));
        } else {
          showAlert("Gagal mengambil data, coba beberapa saat lagi", false);
        }
        setLoading(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal mengambil data, coba beberapa saat lagi",
          false
        );
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, []);

  const handleChangeFoto = (file, path) => {
    setParams((pref) => ({
      ...pref,
      img_preview: path,
      img: file,
    }));
  };

  const addListValues = () => {
    let data = params;
    let newData = {
      idx: Math.floor(Math.random() * 10000),
      title: "",
      desc_id: "",
      desc_en: "",
    };
    data.values.push(newData);

    setParams((pref) => ({
      ...pref,
      ...data,
    }));
  };

  const deleteListValues = (idx) => {
    let data = params;
    let newList = data.values.filter((item) => item.idx !== idx);
    data.values = newList;

    setParams((pref) => ({
      ...pref,
      ...data,
    }));
  };
  return (
    <div className="m-sm-30">
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={11} md={12}>
          <h3 className="fw-bold m-0">Sejarah Perusahaan - Nilai Perusahaan</h3>
        </Grid>
        <Grid item xs={11} md={12}>
          <Card elevation={0} className="p-5">
            {loading ? (
              <div className="text-center">
                <CircularProgress color="primary" size={35} />
              </div>
            ) : (
              <ValidatorForm onSubmit={handleFormSubmit} className="w-full">
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="title_id" className="mb-4">
                      Judul [ID] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="title_id"
                      placeholder="Judul"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="title_id"
                      value={params?.title_id || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Judul terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="title_en" className="mb-4">
                      Judul [EN] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="title_en"
                      placeholder="Judul"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="title_en"
                      value={params?.title_en || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Judul terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <UploadImage
                      uploadFoto={handleChangeFoto}
                      label="Unggah Foto"
                      preview={params?.img_preview}
                      required={true}
                      noCrop
                      note={[
                        "Format PNG, WEBP dan JPG diperbolehkan",
                        "*Ukuran foto 742 x 791",
                      ]}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <h5 className="fw-bold mb-5 mt-5">Data</h5>
                  </Grid>
                  {params?.values?.map((item, index) => (
                    <>
                      <Grid item xs={3}>
                        <InputLabel
                          htmlFor="relation_guides_title_id"
                          className="mb-4 h-20"
                        >
                          Judul
                          <span className="text-danger">*</span>
                        </InputLabel>
                        <TextValidator
                          id="title"
                          placeholder="Title"
                          className="w-full"
                          variant="outlined"
                          onChange={(e) => handleChangeValues(e, index)}
                          type="text"
                          name="title"
                          value={item.title || ""}
                          validators={["required"]}
                          errorMessages={["Masukkan judul terlebih dahulu"]}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <InputLabel htmlFor="desc_id" className="mb-4 h-20">
                          Sub Judul [ID]
                          <span className="text-danger">*</span>
                          <Tooltip
                            title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                            placement="top-start"
                            arrow
                          >
                            <InfoOutlined
                              fontSize="small"
                              color="action"
                            ></InfoOutlined>
                          </Tooltip>
                        </InputLabel>
                        <TextValidator
                          id="desc_id"
                          placeholder="Text"
                          className="w-full"
                          variant="outlined"
                          onChange={(e) => handleChangeValues(e, index)}
                          type="text"
                          name="desc_id"
                          value={item.desc_id || ""}
                          validators={["required"]}
                          errorMessages={["Masukkan sub judul terlebih dahulu"]}
                          multiline
                          maxRows={16}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <InputLabel htmlFor="desc_en" className="mb-4 h-20">
                          Sub Judul [EN] <span className="text-danger">*</span>
                          <Tooltip
                            title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                            placement="top-start"
                            arrow
                          >
                            <InfoOutlined
                              fontSize="small"
                              color="action"
                            ></InfoOutlined>
                          </Tooltip>
                        </InputLabel>
                        <TextValidator
                          id="desc_en"
                          placeholder="Text"
                          className="w-full"
                          variant="outlined"
                          onChange={(e) => handleChangeValues(e, index)}
                          type="text"
                          name="desc_en"
                          value={item.desc_en || ""}
                          validators={["required"]}
                          errorMessages={["Masukkan sub judul terlebih dahulu"]}
                          multiline
                          maxRows={16}
                        />
                      </Grid>
                      {index + 1 === params?.values?.length ? (
                        <Grid item xs={1}>
                          <IconButton
                            aria-label="trash"
                            color="danger"
                            className="mt-9 bg-error text-white"
                            onClick={() => deleteListValues(item.idx)}
                          >
                            <DeleteRounded fontSize="small" />
                          </IconButton>
                          <IconButton
                            aria-label="trash"
                            className="mt-9 bg-secondary text-white"
                            onClick={addListValues}
                          >
                            <AddRounded fontSize="small" />
                          </IconButton>
                        </Grid>
                      ) : (
                        <Grid item xs={1}>
                          <IconButton
                            aria-label="trash"
                            color="danger"
                            className="mt-9 bg-error text-white"
                            onClick={() => deleteListValues(item.idx)}
                          >
                            <DeleteRounded fontSize="small" />
                          </IconButton>
                        </Grid>
                      )}
                    </>
                  ))}
                </Grid>

                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="flex-end"
                    className="flex-column-reverse flex-md-row mt-20"
                  >
                    <Grid item xs={12} md={2}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className="text-white w-full radius-6 text-capitalize py-2"
                        disableElevation
                        disabled={submit}
                      >
                        {submit ? (
                          <CircularProgress color="primary" size={25} />
                        ) : (
                          "Simpan Data"
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </ValidatorForm>
            )}
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Values;
